import React, {FormEvent, useEffect, useState} from 'react';
import {
    useGetStorefrontSubExtensionReferencesQuery,
} from '../../store/Api';
import {
    useGetGlobalStorefrontSettingsQuery
} from '../../store/endpoints/StorefrontSettingsEndpoints';
import {Dropdown, IDropdownOption, Spinner} from '@fluentui/react';
import {IExtensionFolioSubextensionReference} from "../../models/Extension";

interface IStorefrontOpportunityExtensionSelection {
    extension?: string;
    label?: string;
    onChange: (extension: string) => void;
}

const StorefrontOpportunityExtensionSelection: React.FC<IStorefrontOpportunityExtensionSelection> = ({extension, onChange}) => {
    const extensionsApi = useGetStorefrontSubExtensionReferencesQuery()
    const globalSettingsApi = useGetGlobalStorefrontSettingsQuery();
    const [extensionOptions, setExtensionOptions] = useState<IDropdownOption[]>()
    const change = (e: FormEvent<HTMLDivElement>, v?: IDropdownOption<any> | undefined) => {
        if (v == null) return;
        onChange(v.key as string);
    }

    useEffect(() => {
        if(extensionsApi.data && globalSettingsApi.data) {
            const globalName = globalSettingsApi.data?.opportunityExtension ? extensionsApi.data?.find(a => globalSettingsApi.data?.opportunityExtension == `folio_${a.sourceFolio}_${a.identifier}`)?.name : undefined;
            const options = [{key: '', text: (globalName? `${globalName} (Inherited from global settings)` : 'Not Set')}, ...extensionsApi.data.map((extension: IExtensionFolioSubextensionReference) => ({
                key: `folio_${extension.sourceFolio}_${extension.identifier}`,
                text: extension.name ?? ''
            }))]
            setExtensionOptions(options);
        }
    }, [extensionsApi.data, globalSettingsApi.data]);
    
    

    return (
        <>
        {(extensionsApi.isLoading || extensionsApi.isFetching) ? <Spinner></Spinner> :
            (extensionOptions && extensionOptions.length > 0) ? 
            <Dropdown
                label='Opportunity Extension'
                selectedKey={extension}
                onChange={change}
                options={extensionOptions}
                styles={{root: {maxWidth: 468}}}
            /> : <div> No Opportunity Extensions Installed</div>}</>
    );
}

export default StorefrontOpportunityExtensionSelection;